module.exports = __webpack_public_path__ + "img/card_lock.c47eea63.png";